<template>
  <div class="main-wrapper">
    <p>
      Я выражаю свое согласие на автоматизированную, а также без использования
      средств автоматизации обработку в {{ bankName }} (адрес: 115093, г.
      Москва, ул. Дубининская, д. 86) в соответствии с Федеральным законом
      №152-ФЗ "О персональных данных" моих персональных данных (включая
      полученные от меня и/или от любых третьих лиц), а также персональных
      данных третьих лиц по моему поручению, которые я передаю Банку для
      достижения целей, указанных в настоящем согласии. Я заверяю Банк, что
      согласия указанных третьих лиц на обработку персональных данных в целях и
      в порядке, указанных в настоящем согласии, мною получены и по требованию
      Банка могут быть представлены Банку.
    </p>
    <p>
      Согласие дается мной для целей: заключения любых договоров с Банком и их
      дальнейшего исполнения, оказания Банком услуг, участия в проводимых Банком
      акциях, опросах, исследованиях через любые каналы коммуникации, в том
      числе по почте, смс, электронной почте, телефону, мобильному телефону и
      иным средствам связи, принятия решений или совершения иных действий,
      порождающих юридические последствия в отношении меня или других лиц,
      представления в мой адрес информации об оказываемых Банком услугах. Банк
      вправе осуществлять обработку предоставляемых персональных данных, а
      именно: фамилия, имя, отчество, год, месяц, дата и место рождения, адрес
      регистрации по месту жительства, пребывания, реквизиты документа
      удостоверяющего личность, семейное, социальное, имущественное положение,
      образование, профессия, доходы, номера контактных телефонов и адресов
      электронной почты, а также иные сведения, относящиеся к моей личности или
      к третьим лицам, которые связаны с выполнением обязательств по договорным
      отношениям с Банком (далее - Персональные данные). В целях изготовления
      банковской пластиковой карты я даю согласие Банку предоставлять
      Персональные данные в ПАО Банк «ФК Открытие», 115114, г. Москва, ул.
      Летниковская, д.2, стр.4 (далее Оператор) (или правопреемнику Оператора).
    </p>
    <p>
      Настоящее согласие предоставляется на осуществление любых действий в
      отношении Персональных данных, необходимых или желаемых для достижения
      каждой из указанных выше целей, включая без ограничения: сбор, запись,
      систематизацию, накопление, хранение, уточнение (обновление, изменение),
      извлечения, использование, передачу (предоставление, доступ) этих данных
      третьим лицам (на основании договоров, включающих обязательства таких
      третьих лиц обеспечить конфиденциальность полученных от Банка данных),
      обезличивание, блокирование, удаление и уничтожение этих данных в порядке
      и способом исключительно по усмотрению Банка и в соответствии с
      действующим законодательством РФ.
    </p>
    <p>
      Согласие действует до истечения сроков хранения соответствующей информации
      или документов, содержащих указанную выше информацию, в соответствии с
      действующим законодательством РФ и может быть отозвано Клиентом путем
      направления соответствующего письменного уведомления Банку или Оператору
      не менее чем за три месяца до момента отзыва согласия, при этом операторы
      прекращают обработку персональных данных и уничтожают их, за исключением
      персональных данных, включенных в документы, обязанность по хранению
      которых прямо предусмотрена законодательством РФ. Хранение таких
      Персональных данных осуществляется операторами в течение срока,
      установленного законодательством РФ. В случае отзыва согласия обработка
      Персональных данных будет прекращена Банком и/или третьими лицами при
      условии полного погашения задолженности перед Банком по любым заключенным
      Клиентом с Банком договорам.
    </p>
    <div id="bottom-text">
      <input
        type="checkbox"
        id="checkbox"
        v-model="IS_PERSDATA_GRANTED"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('IS_PERSDATA_GRANTED') != -1
        "
      />
      <label for="checkbox">
        Я согласен на обработку персональных данных
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPpicy",
  props: {
    pageInfo: {},
    bankName: String,
    pageName: String,
  },
  data() {
    return {
      serverInfo: {},
      IS_PERSDATA_GRANTED: false,
    };
  },
  methods: {
    validation() {
      var msg = this.IS_PERSDATA_GRANTED
        ? ""
        : "Необходимо дать согласие обработку персональных данных";
      this.$emit("enableButtons", true, msg);
      if (this.IS_PERSDATA_GRANTED) {
        this.serverInfo.IS_PERSDATA_GRANTED = this.IS_PERSDATA_GRANTED;
        this.$emit("changePageSendData", this.serverInfo, false);
      }
    },
  },
  async created() {
    this.serverInfo.INN = this.pageInfo.INN;
    this.serverInfo.ID = this.pageInfo.ID;
    this.serverInfo.UPDATE_DATE = this.pageInfo.UPDATE_DATE;

    this.IS_PERSDATA_GRANTED =
      this.pageInfo.IS_PERSDATA_GRANTED != null &&
      this.pageInfo.IS_PERSDATA_GRANTED;

    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  font-size: 15px;
  text-align: justify;
}
</style>
